import styled, { css } from "styled-components";
import { variables } from "../variables";
import { device } from "../mediaQueries";

export default styled.div`
  /* grid-template-columns: repeat(auto-fit, minmax(270px, 1fr)); */
`;
